import React, { useState } from 'react';
import { Header } from './components/Header';
import { SearchBar } from './components/SearchBar';
import { TabNavigation } from './components/TabNavigation';
import { HomeTab } from './components/HomeTab';
import { ProtocolsTab } from './components/ProtocolsTab';
import { SystemsTab } from './components/SystemsTab';
import { PatternsTab } from './components/PatternsTab';
import { MirroringTab } from './components/MirroringTab';
import { HologramTab } from './components/HologramTab';
import { TungPointsTab } from './components/TungPointsTab';
import { GlobalBalanceTab } from './components/GlobalBalanceTab';
import { SeasonalBalanceTab } from './components/SeasonalBalanceTab';
import { AboutTab } from './components/AboutTab';
import { BaGuaTab } from './components/BaGuaTab';
import { IChingTab } from './components/IChingTab';
export function App() {
  const [activeTab, setActiveTab] = useState('home');
  const [searchTerm, setSearchTerm] = useState('');
  const tabs = [{
    id: 'home',
    label: 'Home'
  }, {
    id: 'systems',
    label: 'Six Systems'
  }, {
    id: 'protocols',
    label: 'Treatment Protocols'
  }, {
    id: 'patterns',
    label: 'Pattern Protocols'
  }, {
    id: 'mirroring',
    label: 'Mirroring & Imaging'
  }, {
    id: 'hologram',
    label: 'Hologram Theory'
  }, {
    id: 'global',
    label: 'Global Balance'
  }, {
    id: 'seasonal',
    label: 'Seasonal Balance'
  }, {
    id: 'bagua',
    label: 'Ba Gua Conversion'
  }, {
    id: 'iching',
    label: 'I-Ching System'
  }, {
    id: 'tung',
    label: "Master Tung's Points"
  }, {
    id: 'about',
    label: 'About & Guide'
  }];
  return <div className="min-h-screen w-full bg-gradient-to-br from-teal-600 via-teal-700 to-teal-900 p-5" data-id="element-0">
      <div className="max-w-7xl mx-auto" data-id="element-1">
        <Header data-id="element-2" />
        <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} data-id="element-3" />
        <TabNavigation tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} setSearchTerm={setSearchTerm} data-id="element-4" />
        <div className="mt-8" data-id="element-5">
          {activeTab === 'home' && <HomeTab setActiveTab={setActiveTab} data-id="element-6" />}
          {activeTab === 'protocols' && <ProtocolsTab searchTerm={searchTerm} data-id="element-7" />}
          {activeTab === 'systems' && <SystemsTab searchTerm={searchTerm} data-id="element-8" />}
          {activeTab === 'patterns' && <PatternsTab searchTerm={searchTerm} data-id="element-9" />}
          {activeTab === 'mirroring' && <MirroringTab searchTerm={searchTerm} data-id="element-10" />}
          {activeTab === 'hologram' && <HologramTab searchTerm={searchTerm} data-id="element-11" />}
          {activeTab === 'global' && <GlobalBalanceTab searchTerm={searchTerm} data-id="element-12" />}
          {activeTab === 'seasonal' && <SeasonalBalanceTab searchTerm={searchTerm} data-id="element-13" />}
          {activeTab === 'bagua' && <BaGuaTab searchTerm={searchTerm} data-id="element-14" />}
          {activeTab === 'iching' && <IChingTab searchTerm={searchTerm} data-id="element-15" />}
          {activeTab === 'tung' && <TungPointsTab searchTerm={searchTerm} data-id="element-16" />}
          {activeTab === 'about' && <AboutTab data-id="element-17" />}
        </div>
      </div>
    </div>;
}